import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconAddUser } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
/**
 * An abstract implementation of a button for accessing settings.
 */
class CredentialRegisterButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.CredentialRegister';
    icon = IconAddUser;
    label = 'toolbar.CredentialRegister';
    tooltip = 'toolbar.CredentialRegister';
    /**
     * Handles clicking / pressing the button, and opens the appropriate dialog.
     *
     * @protected
     * @returns {void}
     */
    _handleClick() {
        window.open('https://signup.meet.authkey.cn/', '_blank');
    }
}
export default translate(connect()(CredentialRegisterButton));
